/**
 * 指定した桁の位置で
 * @param target 対象
 * @param digit 桁数（負の数なら小数点以下切り捨て）
 */
const floorNumber = (target: number, digit: number): number => {
  const pow = 10 ** (-1 * digit);

  return Math.floor(target * pow) / pow;
};

/**
 * 小数点以下の桁数
 * @param target 調査対象の数字
 * @returns 小数点以下の桁数
 */
const numberOfDecimalPlaces = (target: number): number => {
  const numbers = String(target).split('.');
  const digit = numbers[1] ? numbers[1].length : 0;

  return digit;
};

export { floorNumber, numberOfDecimalPlaces };
